import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-document-actions',
	standalone: true,
	imports: [CommonModule, TranslatePipe, ButtonComponent],
	templateUrl: './document-actions.component.html',
	styleUrls: ['./document-actions.component.scss'],
})
export class DocumentActionsComponent {
	/**
	 * Método para obtener el documento: 'photo' | 'manual' | 'both'
	 */
	@Input() method: 'photo' | 'manual' | 'both' = 'both';

	/**
	 * Indica si hay archivos PDF en el documento
	 */
	@Input() hasPdfFiles: boolean = false;

	/**
	 * Evento cuando se hace clic en el botón de explorar
	 */
	@Output() exploreClicked = new EventEmitter<void>();

	/**
	 * Evento cuando se hace clic en el botón de tomar foto
	 */
	@Output() takePhotoClicked = new EventEmitter<void>();

	/**
	 * Determina si se debe mostrar el botón de explorar
	 */
	get showExploreButton(): boolean {
		return this.method === 'manual' || this.method === 'both';
	}

	/**
	 * Determina si se debe mostrar el botón de tomar foto
	 */
	get showTakePhotoButton(): boolean {
		return (this.method === 'photo' || this.method === 'both') && !this.hasPdfFiles;
	}

	/**
	 * Maneja el clic en el botón de explorar
	 */
	onExploreClick(): void {
		this.exploreClicked.emit();
	}

	/**
	 * Maneja el clic en el botón de tomar foto
	 */
	onTakePhotoClick(): void {
		this.takePhotoClicked.emit();
	}
}
